document.addEventListener("DOMContentLoaded", function () {
  const canvas = document.createElement("canvas");
  document.body.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  canvas.style.position = "fixed";
  canvas.style.top = "0";
  canvas.style.left = "0";
  canvas.style.pointerEvents = "none";
  canvas.style.zIndex = "9999";

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resizeCanvas();
  window.addEventListener("resize", resizeCanvas);

  class Particle {
    constructor(x, y, angle, speed, color) {
      this.x = x;
      this.y = y;
      this.angle = angle;
      this.speed = speed;
      this.color = color;
      this.alpha = 1;
      this.decay = Math.random() * 0.015 + 0.007;
      this.length = Math.random() * 15 + 10;
    }
    update() {
      this.x += Math.cos(this.angle) * this.speed;
      this.y += Math.sin(this.angle) * this.speed;
      this.alpha -= this.decay;
    }
    draw(ctx) {
      ctx.save();
      ctx.globalAlpha = this.alpha;
      ctx.strokeStyle = this.color;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(this.x, this.y);
      ctx.lineTo(
        this.x - Math.cos(this.angle) * this.length,
        this.y - Math.sin(this.angle) * this.length
      );
      ctx.stroke();
      ctx.restore();
    }
  }

  class Firework {
    constructor(startX, targetX, targetY) {
      this.x = startX;
      this.y = canvas.height; // नेहमी खालीपासून सुरू
      this.targetX = targetX;
      this.targetY = targetY;
      this.exploded = false;
      this.trail = [];
      this.particles = [];
      this.color = `hsl(${Math.random() * 360}, 100%, 60%)`;
      this.speed = 8;
    }
    update() {
      if (!this.exploded) {
        this.trail.push({ x: this.x, y: this.y });
        if (this.trail.length > 10) this.trail.shift();

        const dx = this.targetX - this.x;
        const dy = this.targetY - this.y;
        const dist = Math.sqrt(dx * dx + dy * dy);

        this.x += (dx / dist) * this.speed;
        this.y += (dy / dist) * this.speed;

        if (dist < 10) {
          this.exploded = true;
          for (let i = 0; i < 120; i++) {
            const angle = Math.random() * Math.PI * 2;
            const speed = Math.random() * 6 + 2;
            this.particles.push(new Particle(this.x, this.y, angle, speed, this.color));
          }
        }
      } else {
        this.particles.forEach(p => p.update());
        this.particles = this.particles.filter(p => p.alpha > 0);
      }
    }
    draw(ctx) {
      if (!this.exploded) {
        // फक्त trail, dot नाही
        ctx.strokeStyle = this.color;
        ctx.beginPath();
        for (let i = 0; i < this.trail.length - 1; i++) {
          ctx.moveTo(this.trail[i].x, this.trail[i].y);
          ctx.lineTo(this.trail[i + 1].x, this.trail[i + 1].y);
        }
        ctx.stroke();
      }
      this.particles.forEach(p => p.draw(ctx));
    }
  }

  let fireworks = [];
  let running = true;

  function loop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    fireworks.forEach(f => {
      f.update();
      f.draw(ctx);
    });

    fireworks = fireworks.filter(f => !f.exploded || f.particles.length > 0);

    if (running) requestAnimationFrame(loop);
  }

  const interval = setInterval(() => {
    const startX = Math.random() * canvas.width;
    const targetX = Math.random() * canvas.width;
    const targetY = Math.random() * (canvas.height / 2); // वरच्या अर्ध्यात फुटणार
    fireworks.push(new Firework(startX, targetX, targetY));
  }, 2000);

  // 20 सेकंदानंतर थांबव
setTimeout(() => {
  clearInterval(interval);
  running = false;
  document.body.removeChild(canvas); // साफसफाई
}, 20000);
  loop();
});
